export default __webpack_public_path__ + "static/media/CORFO.e668f5b3.svg";